// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".feedback-survey .md-dialog-content{margin:0 10px 4px 10px}", "",{"version":3,"sources":["webpack://./src/components/common/feedback/FeedbackModal.vue"],"names":[],"mappings":"AAEE,oCACE,sBAAA","sourcesContent":["\n.feedback-survey {\n  .md-dialog-content {\n    margin: 0 10px 4px 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
